import Swiper from '@src/components/swiper';

export const moreThanThreeCardsSwiperCards = new Swiper('.swiper-cards-more-than-three-cards', {
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination-cards',
    clickable: true
  },
  slidesPerView: 'auto',
  centeredSlides: false,
  breakpoints: {
    // On desktop and bigger.
    768: {
      spaceBetween: 24,
    },
    // On mobile (>= 1px).
    1: {
      spaceBetween: 48,
    }
  }
});
